// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';
import LinkText from '@tcp/core/src/components/common/molecules/LinkText';

const getLayoutView = (layout) => {
  if (layout === 'stacked') {
    return `flex-direction: row;`;
  }
  return `flex-direction: column;`;
};

export const StyledHeaderSection = styled.section`
  display: flex;
  width: 100%;

  @media ${(props) => props.theme.mediaQuery.large} {
    margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    justify-content: center;
    align-items: center;
  }
  ${(props) => (props.layout ? getLayoutView(props.layout) : '')}
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    flex-direction: column;
  }
`;

export const StyledHeadingText = styled(LinkText)`
  line-height: ${(props) => props.theme.spacing.ELEM_SPACING.XL_1};
`;

export const StyledSubHeadingText = styled(LinkText)`
  display: flex;
  align-items: center;
  padding-left: 0;
  line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED_2};
`;
